import './i18n.js'  // sets window.I18n; must be first so other modules can use it
import { MapBox, SiteMarker, SitePicker, CoordsPicker } from './components/map-box.js'
import { GeoInput } from './components/geo-input.js'
import { MapVectorLayer, MapGpxLayer } from './components/map-layers.js'
import { MapFeatureInfo } from './components/map-feature-info.js'
import { WeatherStationPicker } from './components/weather-station-picker.js'
import './components/amphis-feature-styles.js'

customElements.define('map-box', MapBox);
customElements.define('site-marker', SiteMarker);
customElements.define('site-picker', SitePicker);
customElements.define('coords-picker', CoordsPicker);
customElements.define('geo-input', GeoInput);
customElements.define('map-vector-layer', MapVectorLayer);
customElements.define('map-gpx-layer', MapGpxLayer);
customElements.define('map-feature-info', MapFeatureInfo);
customElements.define('weather-station-picker', WeatherStationPicker);

import "./components/activity-chart.js"
import "./components/analysis-chart.js"

import ObservationsDiagram from "./components/observations-diagram.js"
customElements.define('observations-diagram', ObservationsDiagram);

import YearlyActivity from "./components/yearly-activity-chart.js"
customElements.define('yearly-activity', YearlyActivity);

import TourButton from "./components/tour-button.js"

customElements.define('tour-button', TourButton);
